<div id="background-container">
  <div id="temporary-container">
    <span id="temporary-span">
      Deze pagina is nog niet beschikbaar.
      <br/>Er wordt hard gewerkt om deze zo snel mogelijk voor u beschikbaar te stellen.
    </span>
  </div>
</div>
